module.exports = __webpack_public_path__ + "img/gift7-04-c1.cae3a3a0.png";